import Vue from 'vue'

//@ts-ignore
//TODO SelecionarBancos.vue Refactor to TSX
Vue.component('attaSelecionarBancos', () => import('./Inputs/SelecionarBancos.vue'))

Vue.component('attaSelecionarEstado', () => import('./Inputs/SelectState'))

//@ts-ignore
//TODO InputBasico.vue Refactor to TSX
Vue.component('attaInputBasico', () => import('./Inputs/InputBasico'))

//@ts-ignore
//TODO InputCPF.vue Refactor to TSX
Vue.component('attaInputCpf', () => import('./Inputs/InputCPF'))

//@ts-ignore
//TODO InputData.vue Refactor to TSX
Vue.component('attaInputData', () => import('./Inputs/InputData'))

//@ts-ignore
//TODO InputCEP.vue Refactor to TSX
Vue.component('attaInputCep', () => import('./Inputs/InputCEP'))

//@ts-ignore
//TODO InputTelefone.vue Refactor to TSX
Vue.component('attaInputTelefone', () => import('./Inputs/InputTelefone'))

//@ts-ignore
//TODO InputEmail.vue Refactor to TSX
Vue.component('attaInputEmail', () => import('./Inputs/InputEmail'))

//@ts-ignore
//TODO VNumericField.vue Refactor to TSX
Vue.component('VNumericField', () => import('./Inputs/VNumericField.vue'))

//@ts-ignore
//TODO attaAvatar.vue Refactor to TSX
Vue.component('attaAvatar', () => import('./attaAvatar.vue'))

//@ts-ignore
//TODO inputSexo.vue Refactor to TSX
//Vue.component('attaInputSexo', () => import('./Inputs/inputSexo.vue'))

//@ts-ignore
//TODO InputDatePicker.vue Refactor to TSX
Vue.component('attaInputDatePicker', () => import('./Inputs/InputDatePicker.vue'))

//@ts-ignore
//TODO InputDatePickerRange.vue Refactor to TSX
Vue.component('attaInputDatePickerRange', () => import('./Inputs/InputDatePickerRange.vue'))

//@ts-ignore
//TODO InputCPFCapitalizacao.vue Refactor to TSX
Vue.component('attaInputCpfCapitalizacao', () => import('./Inputs/InputCPFCapitalizacao.vue'))

//@ts-ignore
//TODO InputCNPJ.vue Refactor to TSX
Vue.component('attaInputCnpj', () => import('./Inputs/InputCNPJ'))

//@ts-ignore
//TODO InputFilter.vue Refactor to TSX
//Vue.component('attaInputFilter', () => import('./Inputs/InputFilter.vue'))

Vue.component('attaInputMoney', () => import('./Inputs/InputMoney'))
Vue.component('attaInputCidade', () => import('./Inputs/InputCidade'))
Vue.component('attaInputCelular', () => import('./Inputs/InputCelular'))

export * from './App/User/AppUser'
export * from './App/Obfuscate/ObfuscateField'
export * from './App/Obfuscate/ObfuscateView'
export * from './App/SheetGrid/SheetGrid'
export * from './App/SheetGrid/SheetGridHighlight'
export * from './App/ExpansionPanels/ExpansionPanel'
export * from './App/GenericDrawer/GenericDrawer'
export * from './App/AppAvatar/AppAvatar'
export * from './App/Alert/AlertBasico'
export * from './App/DataTable/DataTable'
export * from './App/ToolbarTitle/ToolbarTitle'
export * from './App/GenericChips'
export * from './Inputs'
export * from './App/Dialog'
export * from './App/QRCode/AppQRCode'
export * from './App/GenericModal/GenericModal'
export * from './App/Error/Error'
export * from './App/ModalCancelamento/ModalCancelamento'
export * from './App/EntityUpdateModal/EntityUpdateModal'
export * from './App/ProgressoForm/ProgressoForm'
export * from './App/ProgressoForm/ProgressoFormWrapper'
export * from './FormComponent'
export * from './App/Error/AppErrorDialog'
export * from './App/ValuesConfirmationForm/ValuesConfirmationForm'
export * from './App/ShareLink/ShareLink'
export * from './App/IFrame/IFrame'
export * from './App/AppAvatar/Avatar'
export * from './App/AppAvatar/AppAvatar'
export * from './App/SubHeader/SubHeader'
export * from './App/Notification/NotificationDrawer'
export * from './App/Observation/ObservationDrawer'
export * from './App/Snackbar'
